module.exports = __webpack_public_path__ + "static/img/shiming.3dffb00d.png";